<template>
	<router-link :to="link" class="company">
		<img v-if="rowData.creator.avatar" :src="`/images/avatar/${rowData.creator.id}`"
		     class="avatar avatar--small"
		     :title="rowData.creator.name" :alt="`${rowData.creator.name}'s avatar`"
		     width="32" height="32" />
		<img v-else src="//placehold.it/32x32" class="avatar avatar--small" width="32" height="32" />
		<span>{{ rowData.name }}</span>
	</router-link>
</template>

<script>
	export default {
		name: 'ColumnInsight',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		computed: {
			link() {
				if(this.rowData.status === 2) {
					return { name: 'view-document', params: { insight_id: this.rowData.id }}
				} else {
					return { name: 'preview-document', params: { insight_id: this.rowData.id }}
				}
			}
		}
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>

<style lang="scss" scoped>
	@import "~reflex-grid/scss/includes/variables";
	@import "~reflex-grid/scss/includes/mixins";
	@import "~@/theme/_variables.scss";

	.company {
		@include display-flex;
		@include align-items(center);
	}

	.avatar {
		margin-right: 1.5rem;
		@include flex(0, 0);
	}
</style>
